<script setup lang="ts">
import { resolveComponent } from 'vue'
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsBlock']
}>()

const { getCmsSlot, getCmsElementName } = useCms()
const leftSlot = computed(() => getCmsSlot(props.content, 'left'))
const rightSlot = computed(() => getCmsSlot(props.content, 'right'))
</script>

<template>
    <div class="w-full flex flex-col justify-center md:flex-row">
        <div class="w-full md:w-1/2">
            <component
                :is="resolveComponent(getCmsElementName(leftSlot?.type))"
                v-if="leftSlot"
                :content="leftSlot"
            />
        </div>
        <div class="w-full md:w-1/2">
            <component
                :is="resolveComponent(getCmsElementName(rightSlot?.type))"
                v-if="rightSlot"
                :content="rightSlot"
            />
        </div>
    </div>
</template>